export default function AiChatIcon({ color = '#95A065', gradient }: { color?: string; gradient?: boolean }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
      <path
        d="M15.5945 5.94009L15.389 6.41149C15.2387 6.7566 14.7613 6.7566 14.6109 6.41149L14.4055 5.94009C14.0393 5.09956 13.3796 4.43034 12.5564 4.06423L11.9233 3.78268C11.5811 3.63044 11.5811 3.13234 11.9233 2.9801L12.521 2.71428C13.3653 2.33876 14.0368 1.64478 14.3968 0.775692L14.6078 0.266276C14.7548 -0.0887585 15.2452 -0.0887585 15.3922 0.266276L15.6032 0.775692C15.9632 1.64478 16.6347 2.33876 17.479 2.71428L18.0766 2.9801C18.4189 3.13234 18.4189 3.63044 18.0766 3.78268L17.4436 4.06423C16.6204 4.43034 15.9608 5.09956 15.5945 5.94009ZM15 8.33333C15.5579 8.33333 16.0945 8.24192 16.5956 8.07333C16.6425 8.43117 16.6667 8.79608 16.6667 9.16667C16.6667 13.769 12.9357 17.5 8.33333 17.5C6.91458 17.5 5.57867 17.1455 4.40931 16.5202L0 17.5L0.979842 13.0907C0.354533 11.9213 0 10.5854 0 9.16667C0 4.56429 3.73096 0.833334 8.33333 0.833334C9.088 0.833334 9.81925 0.933659 10.5145 1.12169C10.1851 1.78848 10 2.53929 10 3.33333C10 6.09476 12.2386 8.33333 15 8.33333ZM4.16667 9.16667C4.16667 11.4678 6.03215 13.3333 8.33333 13.3333C10.6345 13.3333 12.5 11.4678 12.5 9.16667H10.8333C10.8333 10.5474 9.71408 11.6667 8.33333 11.6667C6.95258 11.6667 5.83333 10.5474 5.83333 9.16667H4.16667Z"
        fill={gradient ? 'url(#paint0_linear_150_6001)' : color}
      />
      <defs>
        <linearGradient
          id="paint0_linear_150_6001"
          x1="9.88812e-08"
          y1="4.92187"
          x2="31.5164"
          y2="12.3771"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64A40A" />
          <stop offset="1" stopColor="#91A80E" />
        </linearGradient>
      </defs>
    </svg>
  );
}
